<template>
  <div class="header">
    <div class="index-consult">
      <img src="@/assets/images_member/Group 90@2x.png" @click="isSideBar = !isSideBar" class="icon-img" alt="">
      <div class="consult-title">
        <div class="txt1">幸福公社AI</div>
        <div class="txt2">
          ALL THE WORLD
        </div>
      </div>
      <img src="@/assets/images_member/Group 494@2x.png" @click="showCode = !showCode" class="img-consult" alt="" />
    </div>

    <van-popup v-model="showCode">
      <div class="popup-div">
        <div class="div-close" @click="showCode = !showCode">
          <img src="@/assets/images_member/Frame@3x.png" class="img-close" alt="" />
        </div>
        <div class="div-txt">联系企业客服</div>
        <img :src="service_qr_code" class="img" alt="" />
        <div class="div-tip">长按图片识别二维码添加企业客服</div>
      </div>
    </van-popup>

    <div class="dailog-sidebar" v-if="isSideBar">
      <div class="dialog-bg" @click="isSideBar = !isSideBar"></div>
      <div class="sidebar-con">
        <div class="con-top" @click="handleJump('PERSONAL')">
          <img :src="userInfo.headimgurl" class="header-conver" alt="">
          <div class="top-div">
            <div class="txt1">{{ userInfo.nickname }}</div>
            <div class="txt2">点击进入个人中心</div>
          </div>
        </div>
        <div class="sidebar-list">
          <div class="item" @click="handleJump('INDEX')">
            <img src="@/assets/images_member/20230807/Frame@2x.png" v-if="itemPath === '/' || itemPath === '/pageHome'" class="item-icon" alt="">
            <img src="@/assets/images_member/Frame@2x(4).png" v-else class="item-icon" alt="">
            <div class="item-txt" :class="itemPath === '/' || itemPath === '/pageHome' ? 'cur' : ''">首页</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
          <div class="item" @click="handlePath('/wine/')">
            <img src="@/assets/images_member/icon-custom.png" class="item-icon" alt="">
            <div class="item-txt">喜酱定制</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
          <div class="item" @click="handleJump('PERSONAL')">
            <img src="@/assets/images_member/20230807/Frame@2x (4).png" v-if="itemPath === '/personal'" class="item-icon" alt="">
            <img src="@/assets/images_member/Frame@2x.png" v-else class="item-icon" alt="">
            <div class="item-txt" :class="itemPath === '/personal' ? 'cur' : ''">会员中心</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
          <div class="item" @click="handleJump('CARD')">
            <img src="@/assets/images_member/Frame@2x(1).png" class="item-icon" alt="">
            <div class="item-txt">我的卡包</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
          <div class="item" @click="handlePath('/xfgpt/')">
            <img src="@/assets/images_member/Group 655@2x.png" class="item-icon" alt="">
            <div class="item-txt">AI 小助手</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
          <div class="item" @click="handleJump('CUSTOM')">
            <img src="@/assets/images_member/Frame@2x(2).png" class="item-icon" alt="">
            <div class="item-txt">我的客户</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
          <div class="item" @click="handleJump('SHAREPOSTER')">
            <img src="@/assets/images_member/Frame@2x(3).png" class="item-icon" alt="">
            <div class="item-txt">邀请好友</div>
            <img src="@/assets/images_member/icon-return.png" class="item-arrow" alt="">
          </div>
        </div>
        <!-- <div class="sider-btn">
          <div class="btn-div">
            <img src="@/assets/images_member/Group 656@2x.png" class="btn-icon" alt="">
            <div class="txt">定制订单</div>
          </div>
          <div class="btn-div">
            <img src="@/assets/images_member/Frame@2x(5).png" class="btn-icon" alt="">
            <div class="txt">账户余额</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {getWxPublicInfo} from '@/api/person'
import { handleGoToPath } from '@/utils/comm'
export default {
  name: 'HeaderComponent',
  data () {
    return {
      showCode: false,
      isSideBar: false,
      userInfo: {},
      service_qr_code: ''
    }
  },
  computed: {
    itemPath() {
      console.log(this.$route.path)
      return this.$route.path
    },
  },
  mounted () {
    this.handleFun()
    this.userInfo = JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
  },
  methods: {
    handlePath(url) {
      handleGoToPath(url)
    },
    handleJump (type) {
      switch (type) {
        case 'PERSONAL':
          this.$router.push({
            path: '/personal'
          })
          break
        case 'INDEX':
          this.$router.push({
            path: '/'
          })
          break
        case 'CARD':
          this.$router.push({
            path: '/pageCard'
          })
          break
        case 'CUSTOM':
          this.$router.push({
            path: '/custom'
          })
          break
        case 'SHAREPOSTER':
          this.$router.push({
            path: '/sharePoster'
          })
          break

        default:
          break
      }
    },
    handleFun() {
      setTimeout(function () {
        getWxPublicInfo().then(res => {
          this.service_qr_code = res.data.service_qr_code
        })
      }, 1000)
    }
  },
}
</script>
<style lang="less" scoped>
.header {
  width: 100vw;
  padding-top: 56px;

  .index-consult {
    display: flex;
    align-items: center;
    height: 56px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background-color: #F0E1C0;
    padding: 0 14px;
    box-sizing: border-box;
    justify-content: space-between;

    .icon-img {
      width: 16px;
      height: 16px;
      position: relative;
      display: block;
      z-index: 9;
    }

    .consult-title {
      display: flex;
      align-items: center;
      flex-direction: column;
      height: 56px;
      justify-content: center;
      position: absolute;
      width: 100vw;
      left: 0;

      .txt1 {
        font-size: 15px;
        font-weight: 600;
        line-height: 15px;
        color: #504632;
      }

      .txt2 {
        margin-top: 4px;
        font-size: 8px;
        color: #958463;
        font-weight: 500;
      }
    }
  }

  .img-consult {
    width: 65px;
    height: 30px;
    display: block;
    position: relative;

  }

  .van-popup {
    width: 300px;
    height: 261px;
    background-color: #2f3131;
    border-radius: 10px;

    .popup-div {
      display: flex;
      flex-direction: column;
      align-items: center;

      .img-close {
        width: 21px;
        height: 21px;
        position: absolute;
        top: 16px;
        right: 16px;
      }

      .div-txt {
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        margin-top: 20px;
        line-height: 18px;
      }

      .img {
        width: 133px;
        height: 133px;
        border-radius: 10px;
        background-color: #fff;
        margin-top: 20px;
      }

      .div-tip {
        font-size: 14px;
        color: #fff;
        font-weight: 500;
        margin-top: 26px;
        line-height: 14px;
      }
    }
  }

  .dailog-sidebar {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    .dialog-bg {
      background-color: rgba(0, 0, 0, .6);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .sidebar-con {
      width: 280px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: #2F3131;

      .con-top {
        display: flex;
        align-items: center;
        padding-top: 30px;
        padding-left: 14px;
        box-sizing: border-box;

        .header-conver {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          border-radius: 50%;
          overflow: hidden;
        }

        .txt1 {
          font-size: 16px;
          color: #fff;
          font-weight: 500;
          margin-bottom: 8px;
          line-height: 16px;
        }

        .txt2 {
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }
      }

      .sidebar-list {
        padding-left: 15px;
        padding-right: 21px;
        box-sizing: border-box;
        margin-top: 20px;

        .item {
          height: 70px;
          display: flex;
          align-items: center;

          .item-icon {
            width: 20px;
            height: 20px;
            display: block;
          }

          .item-txt {
            flex: 1;
            font-size: 16px;
            color: #fff;
            font-weight: 500;
            margin-left: 8px;
            &.cur {
              font-weight: bold;
              color: #F0E1C0;
            }
          }

          .item-arrow {
            width: 6px;
            height: 11px;
            display: block;
          }
        }
      }

      .sider-btn {
        display: flex;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 60px;
        background-color: #1E2020;

        .btn-div {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: center;
          position: relative;

          &::after {
            border-right: 1px solid #494D4D;
            height: 32px;
            content: "";
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
          }

          .btn-icon {
            width: 20px;
            height: 20px;
            display: block;
            margin-right: 8px;
          }

          .txt {
            font-size: 14px;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderComponent.vue